var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { StringExt, Dom } from '../util';
import { Filter } from '../registry';
import { Markup } from '../view';
import { Base } from './base';
export class DefsManager extends Base {
    get cid() {
        return this.graph.view.cid;
    }
    get svg() {
        return this.view.svg;
    }
    get elem() {
        return this.view.defs;
    }
    isDefined(id) {
        return this.svg.getElementById(id) != null;
    }
    filter(options) {
        let filterId = options.id;
        const name = options.name;
        if (!filterId) {
            filterId = `filter-${name}-${this.cid}-${StringExt.hashcode(JSON.stringify(options))}`;
        }
        if (!this.isDefined(filterId)) {
            const fn = Filter.registry.get(name);
            if (fn == null) {
                return Filter.registry.onNotFound(name);
            }
            const markup = fn(options.args || {});
            // Set the filter area to be 3x the bounding box of the cell
            // and center the filter around the cell.
            const attrs = Object.assign(Object.assign({ x: -1, y: -1, width: 3, height: 3, filterUnits: 'objectBoundingBox' }, options.attrs), { id: filterId });
            Dom.createVector(Markup.sanitize(markup), attrs).appendTo(this.elem);
        }
        return filterId;
    }
    gradient(options) {
        let id = options.id;
        const type = options.type;
        if (!id) {
            id = `gradient-${type}-${this.cid}-${StringExt.hashcode(JSON.stringify(options))}`;
        }
        if (!this.isDefined(id)) {
            const stops = options.stops;
            const arr = stops.map((stop) => {
                const opacity = stop.opacity != null && Number.isFinite(stop.opacity)
                    ? stop.opacity
                    : 1;
                return `<stop offset="${stop.offset}" stop-color="${stop.color}" stop-opacity="${opacity}"/>`;
            });
            const markup = `<${type}>${arr.join('')}</${type}>`;
            const attrs = Object.assign({ id }, options.attrs);
            Dom.createVector(markup, attrs).appendTo(this.elem);
        }
        return id;
    }
    marker(options) {
        const { id, tagName, markerUnits, children } = options, attrs = __rest(options, ["id", "tagName", "markerUnits", "children"]);
        let markerId = id;
        if (!markerId) {
            markerId = `marker-${this.cid}-${StringExt.hashcode(JSON.stringify(options))}`;
        }
        if (!this.isDefined(markerId)) {
            if (tagName !== 'path') {
                // remove unnecessary d attribute inherit from standard edge.
                delete attrs.d;
            }
            const pathMarker = Dom.createVector('marker', {
                id: markerId,
                orient: 'auto',
                overflow: 'visible',
                markerUnits: markerUnits || 'userSpaceOnUse',
            }, children
                ? children.map((_a) => {
                    var { tagName } = _a, other = __rest(_a, ["tagName"]);
                    return Dom.createVector(`${tagName}` || 'path', this.normalizeAttrs(Object.assign(Object.assign({}, attrs), other)));
                })
                : [Dom.createVector(tagName || 'path', this.normalizeAttrs(attrs))]);
            this.elem.appendChild(pathMarker.node);
        }
        return markerId;
    }
    normalizeAttrs(attrs) {
        const result = {};
        Object.keys(attrs).forEach((key) => {
            // xlink:href
            if (key.indexOf(':') > 0) {
                result[key] = attrs[key];
            }
            else {
                result[StringExt.kebabCase(key)] = attrs[key];
            }
        });
        return result;
    }
}
//# sourceMappingURL=defs.js.map